import { t } from "@/i18n-js/instance";
import { useIsGlobalThemingEnabled } from "@/react/components/SettingsApp/Site/Pages/Edit/Design/useIsGlobalThemingEnabled";
import { Icon } from "@/react/components/shared/Icon";
import type { IconType } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";

const TOKEN_TYPES: { label: string; icon: IconType; actionView: string }[] = [
  {
    label: t("builder_ui.theme_configuration.site_styles.token_types.colors"),
    icon: "20-builder-theme-colors",
    actionView: "siteColorsList",
  },
  {
    label: t("builder_ui.theme_configuration.site_styles.token_types.styles"),
    icon: "20-builder-theme-styles",
    actionView: "siteStyles",
  },
  {
    label: t("builder_ui.theme_configuration.site_styles.token_types.text"),
    icon: "20-builder-theme-text",
    actionView: "textStyles",
  },
  {
    label: t("builder_ui.theme_configuration.site_styles.token_types.buttons"),
    icon: "20-builder-theme-buttons",
    actionView: "buttonStyles",
  },
];

export const Tokens = () => {
  const isGlobalThemingEnabled = useIsGlobalThemingEnabled();
  const toggleSidebarView = useBuilderStore(state => state.toggleSidebarView);

  if (!isGlobalThemingEnabled) return null;

  return (
    <div className="border-primary border-t px-6">
      {TOKEN_TYPES.map(token => (
        <button
          key={token.label}
          className="border-primary text-dark flex w-full items-center justify-between border-b py-4"
          type="button"
          onClick={() => toggleSidebarView(token.actionView)}
        >
          <div className="flex items-center gap-2">
            <Icon type={token.icon} size={20} />
            <Typography.LabelSm weight="semibold">
              {token.label}
            </Typography.LabelSm>
          </div>
          <Icon type="16-chevron-right" size={16} />
        </button>
      ))}
    </div>
  );
};
